import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ReduxState } from '../../store/state';
import {
  Flex, FormControl, Input, Select, IconButton, Button, Text
} from '@chakra-ui/react';
import { MdEdit, MdLocalShipping, MdCheck, MdClose } from 'react-icons/md';
import { User } from '../../store/user/types';
import { Location as ILocation } from '../../store/location/types';
import { fetchUserLocations } from '../../store/location/initiators';
import { selectLocation, toggleCreateLocationModal } from '../../store/location/actions';
import { AddIcon } from '@chakra-ui/icons';
import CreateLocationModal from './CreateLocationModal';

interface UserLocationFormProps {
  user: User | null;
  locations: ILocation[];
  selectedLocation: ILocation | null;
  fetchUserLocations: (userId: string) => void;
  selectLocation: (location: ILocation) => void;
  toggleCreateLocationModal: () => void;
}

class UserLocationForm extends Component<UserLocationFormProps> {
  state = {
    editLocationFormOpen: false
  }

  componentDidMount = () => {
    if (this.props.user) {
      this.props.fetchUserLocations(this.props.user._id)
    }
    
  }

  render() {
    const { user, locations, selectedLocation } = this.props;
    const { editLocationFormOpen } = this.state;
    if (selectedLocation) {
      return (
        <>
        <Flex direction={'row'} align={'center'}>
          <MdLocalShipping />
          <Text ml={2} fontWeight={'bold'}>Delivery Location</Text>
          {
            !editLocationFormOpen && (
              <Flex>
                <IconButton 
                  onClick={() =>this.setState({ editLocationFormOpen: true })}
                  aria-label='Edit' 
                  borderRadius={25} 
                  ml={1} 
                  variant={'ghost'}
                  size={'sm'}
                >
                  <MdEdit />
                </IconButton>     
                <IconButton 
                  onClick={() => this.props.toggleCreateLocationModal()}
                  aria-label='Edit' 
                  borderRadius={25} 
                  ml={1} 
                  variant={'ghost'}
                  size={'sm'}
                >
                  <AddIcon />
                </IconButton>  
              </Flex>
            )
          }
        </Flex>
        {
          editLocationFormOpen ? (
            <Flex flexDirection="row">
              <Select 
                placeholder='Select a location'
                onChange={(e) => {
                  const locationId = e.target.value;
                  const selectedLocation = locations.find(location => location._id === locationId);
                  if (selectedLocation) {
                    this.props.selectLocation(selectedLocation);
                    this.setState({ editLocationFormOpen: false })
                  }
                }}
                value={`${selectedLocation.name}: ${selectedLocation.address}`} 
                style={{ borderRadius: 25}}
              >
                {locations.map(location => {
                  if (!location.deleted && location._id) {
                    return <option value={location._id} key={location._id}>{`${location.name}: ${location.address}`}</option>
                  }
                  
                })}
              </Select>
            </Flex>
          ) : (
            <Flex direction={'row'} align={'center'}>
              <Text>{selectedLocation.name}: {selectedLocation.address}</Text>      
            </Flex>
          )
        }
        <CreateLocationModal />
        </>
    )
    }

  }
}

const mapStateToProps = (state: ReduxState) => {
  const { locations, selectedLocation } = state.location;
  const { user } = state.user;
  return { locations, user, selectedLocation };
};

export default connect(mapStateToProps, {
  fetchUserLocations,
  selectLocation,
  toggleCreateLocationModal
})(UserLocationForm);